import React, { useState, useRef, useMemo, useEffect } from "react";
import { Controller, get, useFormContext } from "react-hook-form";

import { MDBSelect, MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import dragAndDrop from "../../../components/images/Send_Receive.svg";
import linkicon from "../../../components/images/link.svg";
import remove1 from "../../../components/images/remove.svg";
import { useAutoDeviceButtonContext } from "./AutoDeviceButtonContext";
import { LoadBLFGroupsTemplate } from "./BlfGroupsTemplate";

const myMap = new Map([
  ["1", "User already configured as Line at "],
  ["2", "User already configured as BLA at "],
  ["3", "User already configured as BLF at "],
  ["4", "User already configured as Park at "],
  ["5", "User already configured as Speed Dial at "],
  ["10", "User already configured as BLF Group "],
]);

export default myMap;

function checkUserAlreadyExist(dataListValues, user_value, button_type) {
  const userValueNames = dataListValues.map((item) => ({
    user_or_value: parseInt(item.user_or_value), // Ensure user_or_value is always a string
    button_type: item.button_type,
    button_no: item.button_no,
  }));
  let errorMessage = "";
  let index;
  if (button_type && button_type == 5) {
    index = userValueNames.findIndex(
      (item) =>
        item.user_or_value == user_value && // Compare with converted userValueString
        item.button_type === button_type
    );
  } else {
    index = userValueNames.findIndex(
      (item) => item.user_or_value == user_value && item.button_type !== 5 // Compare with converted userValueString
    );
  }
  if (index !== -1) {
    errorMessage =
      myMap.get(userValueNames[index].button_type + "") +
      userValueNames[index].button_no;
    return {
      exist: true,
      buttonType: userValueNames[index].button_type,
      error: errorMessage,
    };
  } else {
    return { exist: false };
  }
}

function handleMLALines(formMethods, lines) {
  const {
    getValues,
    insertFun,
    removeFun,
    updateFun,
    deviceData,
    buttonInfo,
    setError,
    setList,
  } = formMethods;
  try {
    if (lines > 1) {
      if (lines > deviceData.nolines_supported) {
        setError(`dataList[${buttonInfo.index}].no_of_mla_lines`, {
          type: "required",
          message:
            "Device can support maximum of " +
            deviceData.nolines_supported +
            " lines.",
        });
        return;
      }

      let dataList = getValues("dataList");
      let emptyCount = 0;
      for (let i = buttonInfo.index + 1; i < dataList.length; i++) {
        if (
          dataList[i].button_type == 6 ||
          dataList[i].button_ref == buttonInfo.index
        ) {
          emptyCount++;
        } else if (dataList[i].button_type != 6) {
          break;
        }
      }

      if (lines - 1 > emptyCount) {
        setError(`dataList[${buttonInfo.index}].no_of_mla_lines`, {
          type: "required",
          message:
            "Insufficient continuous lines. Available MLA lines are " +
            emptyCount,
        });
        return;
      }
      // Below are the lines need to delete as they are MLA DUMMY lines.
      let removableLines = dataList
        .filter((item) => item.button_ref == buttonInfo.index)
        .map((item) => item.index);
      for (var i = 0; i < removableLines.length; i++) {
        let jo = {
          button_no: removableLines[i] + 1,
          button_type: 6,
          user_or_value: "",
          user_value_name: "",
          label: "",
          no_of_mla_lines: 0,
          ring_type: 1,
          index: removableLines[i],
        };
        updateFun(removableLines[i], jo);
      }

      let temp = getValues("dataList")[buttonInfo.index];
      const list = [];
      list.push({ ...temp, no_of_mla_lines: lines });
      for (var i = 1; i < lines * 1; i++) {
        let jo = {
          ...temp,
          button_no: temp.button_no + i,
          MLA_DUMMY: true,
          no_of_mla_lines: lines,
          button_ref: temp.index,
          index: temp.index + i,
        };
        console.log(
          "updating function at : " +
          (temp.index + i) +
          ":  jo is : " +
          JSON.stringify(jo)
        );
        updateFun(buttonInfo.index + i, jo);
        list.push(jo);
      }
      console.log("setting list with : " + list.length);
      console.dir(list);
      setList(list);
    } else {
      // Below are the lines need to delete as they are MLA DUMMY lines.
      let removableLines = getValues("dataList")
        .filter((item) => item.button_ref == buttonInfo.index)
        .map((item) => item.index);
      for (var i = 0; i < removableLines.length; i++) {
        let jo = {
          button_no: removableLines[i] + 1,
          button_type: 6,
          user_or_value: "",
          user_value_name: "",
          label: "",
          no_of_mla_lines: 0,
          ring_type: 1,
          index: removableLines[i],
        };
        updateFun(removableLines[i], jo);
      }
      const temp = { ...buttonInfo, no_of_mla_lines: lines };
      //console.log("updateing list with : :" + JSON.stringify(temp));
      setList([temp]);
    }
  } catch (e) {
    console.error("Error in handleMLALines : " + e);
  }
}

const removeDublicateUsers = (dataList, group) => {
  console.log("[removeDublicateUsers] :");
  let filteredBlfgroup = [];
  group.map((grp) => {
    //let user = dataList.filter((data) => (data.buttonType * 1 != 5 && grp.user_or_value == data.user_or_value * 1));
    let user = dataList.find((data) => data.user_or_value * 1 == grp.user_or_value);
    if (!user || (user && user.button_type * 1 == 5)) {
      filteredBlfgroup.push(grp);
    }
  });
  return filteredBlfgroup;
};

const bLF_Error_Checking = (insertBlfgroup, positionIndex, datalist) => {
  console.log("[bLF_Error_Checking] positionIndex :" + positionIndex);
  const configured_Lines = datalist.filter((item, index) => {
    if (index > positionIndex) {
      //not require >= becaus we are doing again -1
      console.log("item: " + index + " idx: " + index);
      return item.button_type !== 6;
    }
  }).length;

  const total_phoneButtons = datalist.length;
  const startButton = positionIndex + 1;

  /* Max Number of Usable Buttons = [Total Phone Buttons - (Start Button -1)]; 14-(4-1) = 11 */
  const max_no_usableBtns = total_phoneButtons - (startButton - 1);

  /*Buttons Required = [BLF Group Buttons + Configured Lines]; 6+2 = 8 */
  const required_buttons = insertBlfgroup.length + configured_Lines;

  console.log(
    "configured_Lines :" +
    configured_Lines +
    " ,total_phoneButtons :" +
    total_phoneButtons +
    " ,startButton :" +
    startButton +
    " ,max_no_usableBtns: " +
    max_no_usableBtns +
    " ,required_buttons :" +
    required_buttons
  );

  /*As Long as Buttons Required <= Max Number of Usable Buttons there is no error, so 8 <= 11 we are good!*/

  if (required_buttons <= max_no_usableBtns) {
    console.log("[bLF_Error_Checking] we are good! No errors");
    return false;
  } else {
    console.log(
      " [bLF_Error_Checking] Insufficient empty buttons to add the BLF Group."
    );
    return true;
  }
};

export const LoadMLATemplate = React.forwardRef((props) => {
  const buttonNo = props.buttonNo;
  const buttonInfo = props.buttonInfo;
  const autoDeviceContext = useAutoDeviceButtonContext();
  const {
    buttonTypes,
    ringTypes,
    pbxUsersList,
    formValues,
    insertFun,
    removeFun,
    updateFun,
    deviceData,
    addBlf,
    blfgroupsInfo,
    togleAlert,
    defaultMlaLines,
    setDefault
  } = autoDeviceContext;

  const buttonsList = [...buttonTypes];
  if (buttonNo * 1 === 1) {
    buttonsList.push({ text: "Line", value: 1 });
  }

  const {
    control,
    register,
    setValue,
    getValues,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext(); // Accessing form context

  const [groupError, setGroupError] = useState(false);
  const [grpInfo, setGrpInfo] = useState({});
  const [mlaLineTimeout, setMLALineTimeout] = useState();
  const formValueObj = getValues("dataList")
    ? getValues("dataList")[props.index]
    : props.buttonInfo;
  const [buttonChange, setButtonChange] = useState(
    formValueObj?.button_type
      ? formValueObj.button_type * 1
      : props.buttonInfo.button_type * 1
  );

  const [lineValue, setLineValue] = useState(formValueObj?.user_or_value * 1);
  const [ringType, setRingType] = useState(formValueObj?.ring_type * 1);
  const [prevringType, prevSetRingType] = useState(formValueObj?.ring_type * 1);
  const [label, setLabel] = useState(formValueObj?.label);
  const [originalLabel, setOriginalLabel] = useState(formValueObj?.label || "");
  const [lineValueName, setLineValueName] = useState(
    formValueObj?.user_value_name
  );

  const [list, setList] = useState([]);
  const [noOfMLALines, setNoOfMLALines] = useState([
    props.buttonInfo.no_of_mla_lines,
  ]);

  useEffect(() => {
    let errorMla = errors.dataList?.length > 0 && errors.dataList[0]?.no_of_mla_lines ? true : false;
    let line = getValues(`dataList.${buttonInfo.index}.no_of_mla_lines`)
    console.log("Mla Lines::::", line)
    console.log("Prev Mla Lines::::", props.noOfMLALines)
    console.log("Error In Mla Lines::::", errorMla)
    if(line< props.noOfMLALines){
      let mlaLines = [];
      mlaLines.push(props.fields[props.index]);
      if (line >0) {
        for (var i = 1; i< line; i++) {
          mlaLines.push(props.fields[props.index + i]);
        }
        setList(mlaLines);
      }
      return
    }

    //Get Count Of Empty Lines 
    let dataList = getValues("dataList");
    let emptyCount = 0;
    for (let i = buttonInfo.index + 1; i < dataList.length; i++) {
      if (
        dataList[i].button_type == 6 ||
        dataList[i].button_ref == buttonInfo.index
      ) {
        emptyCount++;
      } else if (dataList[i].button_type != 6) {
        break;
      }
    }
    console.log("Empty Lines :::::", emptyCount)

    // 
    let mlaLines = [];

    mlaLines.push(props.fields[props.index]);
    if (defaultMlaLines > 0) {
      for (var i = 1; i < defaultMlaLines; i++) {
        mlaLines.push(props.fields[props.index + i]);
      }
      setList(mlaLines);
    }

    //If Insufficient Lines Error And Empty Lines Are Greater Than Equal To Mla Count Then We Add MLA_DUMMY
    if (errorMla && emptyCount + 1 >= line) {
      let temp = getValues("dataList")[buttonInfo.index];
      const list = [];
      list.push({ ...temp, no_of_mla_lines: line });
      for (var i = 1; i < line * 1; i++) {
        let jo = {
          ...temp,
          button_no: temp.button_no + i,
          MLA_DUMMY: true,
          no_of_mla_lines: line,
          button_ref: temp.index,
          index: temp.index + i,
        };
        updateFun(buttonInfo.index + i, jo);
        list.push(jo);
      }
      setList(list);
      clearErrors(`dataList[${buttonInfo.index}].no_of_mla_lines`);
    }
    else setList(mlaLines);

  }, [props.index]);

  useEffect(() => {
    setOriginalLabel(formValueObj?.label || "");
  });
  let lablemaxLength = 24;
  const handleButtonChange = (item) => {
    if (!item) return;
    if (buttonChange == item.value) return;
    clearErrors(`dataList.${props.index}.user_or_value`);
    if (item.value > 10) {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);
      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        return;
      }

      props.buttonInfo.blf_group_id = item.value;

      const blfGroupToInsert = removeDublicateUsers(getValues("dataList"), blfgroupsInfo[item.value]);
      let isError = bLF_Error_Checking(blfGroupToInsert, props.index, getValues("dataList"));
      if (isError) {
        // alert("phone buttons are not sufficient to add BlfGorup");
        let data = {
          type: "popup",
          title: "addBLFGroup",
          text: "addBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      if (blfGroupToInsert && blfGroupToInsert.length > 0) {
        addBlf(props.index, blfGroupToInsert);
      } else {
        return;
      }
      //setValue(`dataList.${props.index}.button_type`, 10);
      setButtonChange(10);
    } else {
      props.buttonInfo.blf_group_id = 0;

      var fieldObj = getValues(`dataList.${props.index}`);
      var jo = {
        ...fieldObj,
        button_type: parseInt(item.value),
        user_or_value: "",
        user_value_name: "",
        label: "",
      };
      console.log("updating Jo to : " + JSON.stringify(jo));
      updateFun(props.index, jo);

      props.buttonInfo.button_type = item.value;
      updateBlanksOnButtonChangeIfMLAExists();
      setButtonChange(item.value);
    }
  };
 const handlLableChange = (item) => {
    if (item.length > 0 && item.length <= 24) {
      clearErrors(`dataList.${props.index}.label`);
    }
    setLabel(item);
    setValue(`dataList.${props.index}.label`, item, {
      shouldDirty: true,
    });
    setValue(`dataList.${props.index}.isLabelEdited`, true, {
    shouldDirty: true,
  });
    updateUserForMLALines(undefined, undefined, item);
      };

  const updateBlanksOnButtonChangeIfMLAExists = () => {
    try {
      // Below are the lines need to delete as they are MLA DUMMY lines.
      let lineData = getValues("dataList")[buttonInfo.index];
      if (lineData?.no_of_mla_lines > 0) {
        getValues("dataList")
          .filter((item) => item.button_ref == buttonInfo.index)
          .map((item) => {

            updateFun(item.index, {
              button_no: item.index + 1,
              button_type: 6,
              user_or_value: "",
              user_value_name: "",
              label: "",
              no_of_mla_lines: 0,
              ring_type: 1,
              index: item.index,
            });
          });

        updateFun(buttonInfo.index, { ...lineData, no_of_mla_lines: 0 });
      }
    } catch (e) {
      console.log("Error in replaceWithBlanksOnButtonChangeIfMLAExists : " + e);
    }
  };

  const handleRingChange = (item) => {
    if (!item) return;
    if (ringType == item.value) return;
    setRingType(item.value * 1);
    setValue(`dataList.${props.index}.ring_type`, item.value, {
      shouldDirty: true,
    });
    setValue(`dataList.${props.index}.ring_type_change`, prevringType, {
      shouldDirty: true,
    });
    updateUserForMLALines(undefined, item.value);
  };

  const updateUserForMLALines = (selectedUser, ringType, label) => {
    try {
      let mlaLines = getValues("dataList")
        .filter((item) => item.button_ref == buttonInfo.index).map((item) => {
          if (selectedUser) {
        updateFun(item.index, {
          ...item,
            user_or_value: selectedUser.value + "",
              label: selectedUser.label,
            user_value_name: selectedUser.text,
            });
          } else if (ringType) {
            updateFun(item.index, {
              ...item,
            ring_type: ringType,
          });
          } else if (label || label == "") {
            updateFun(item.index, {
              ...item,
              label: label,
        });
          }
      });
  } catch (e) {
    console.log("error " + e);
  }
};

  const handleUserChange = (item1, buttonTypes) => {
    if (!item1) return;
    if (item1.value == lineValue) return;
    console.log("handleUserChange in BLF : " + item1.value + ": " + lineValue);
    let dataListValues = getValues("dataList");
    let data = checkUserAlreadyExist(dataListValues, item1.value, buttonTypes);
    if (data?.exist && item1.value !== lineValue && data?.error !== "") {
      setError(`dataList.${props.index}.user_or_value`, {
        message: data?.error,
      });
      return; // Don't allow selection
    }
    clearErrors(`dataList.${props.index}.user_or_value`);

    const [selectedUser] = pbxUsersList.filter(
      (item) => item.value == item1.value
    );
    if (selectedUser) {
      setLineValue(selectedUser.value);
      let newLabel = selectedUser.label ? selectedUser.label.substring(0,24) : "";
      setLabel(newLabel);
      setLineValueName(selectedUser.text);

      var fieldObj = getValues(`dataList.${props.index}`);
      var jo = {
        ...fieldObj,
        button_type: props.buttonInfo.button_type,
        user_or_value: selectedUser.value + "",
        user_value_name: selectedUser.text,
        label: newLabel,
      };
      console.log("updating Jo to : " + JSON.stringify(jo));
      if (newLabel && newLabel.trim() !== "") {
        clearErrors(`dataList.${props.index}.label`);
      }
      updateFun(props.index, jo);
      updateUserForMLALines(selectedUser);
    }
  };

  const onChangeLabelName = (e) => {
    setLabel(e.target.value);
  };

  const mlaLinesChange = (e) => {

    e.stopPropagation();
    console.log("No.of MLA lines are : " + e.target.value);
    let lines = 0;
    try {
      lines = parseInt(e.target.value);
    } catch (e) { }

    setValue(`dataList.${buttonInfo.index}.no_of_mla_lines`, lines);
    clearTimeout(mlaLineTimeout);
    setMLALineTimeout(
      setTimeout(function () {
        handleMLALines(
          {
            getValues: getValues,
            insertFun: insertFun,
            removeFun: removeFun,
            updateFun: updateFun,
            deviceData: deviceData,
            buttonInfo: buttonInfo,
            setError: setError,
            setList: setList,
          },
          lines
        );
      }, 1000)
    );
  };

  return (
    <>
      {(buttonChange == 1 || buttonChange == 2) && (
        <>
          <tr
            className="dragItem"
            key={props.id}
            ref={props.provided.innerRef}
            {...props.provided.draggableProps}
            {...props.provided.dragHandleProps}
            style={props.style}
          >
            <td key={props.id} colSpan="7" className="w-100 p-0 ">
              <table
                key={props.id}
                className="datatable table-responsive mt-0 table2 w-100 p-0"
              >
                {list.map((item) => {
                  return (
                    <>
                      <tr key={item.id} className="table2">
                        <th className="w-10">
                          <img
                            className={`link-icon pe-1 pb-1 ${item?.hasOwnProperty("MLA_DUMMY") ? "ms-4" : ""}`}
                            src={
                              item?.hasOwnProperty("MLA_DUMMY")
                                ? linkicon
                                : dragAndDrop
                            }
                            alt="Remove"
                          />
                          <input
                            type="hidden"
                            {...register(`dataList.${item.index}.button_no`)}
                            value={item.button_no}
                          />
                          {item.index + 1}
                        </th>

                        <td>
                          {!item.hasOwnProperty("MLA_DUMMY") && (
                            <>
                              <div className="d-flex">
                                <div className="phoneselect">
                                  <Controller
                                    name={`dataList.${item.index}.button_type`}
                                    control={control}
                                    shouldUnregister="true"
                                    defaultValue={buttonChange}
                                    rules={{}}
                                    render={({
                                      field: { onChange, onBlur, value, ref },
                                    }) => (
                                      <MDBSelect
                                        onChange={(item1) =>
                                          handleButtonChange(item1)
                                        }
                                        data={buttonsList}
                                        value={buttonChange}
                                        className="w-200px"
                                        disabled={
                                          item.hasOwnProperty("MLA_DUMMY") ||
                                          props.buttonNo == 1
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              <div>
                                {groupError && <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                                  <b className="text-danger">{grpInfo.text}</b> already assigned to a button.
                                </p>}
                              </div>
                            </>
                          )}
                        </td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect">
                              <input
                                type="hidden"
                                name={`dataList.${item.index}.user_value_name`}
                                value={lineValueName}
                              />


                              <Controller
                                name={`dataList.${props.index}.user_or_value`}
                                control={control}
                                shouldUnregister="true"
                                rules={{ required: "Please select user" }}
                                defaultValue={lineValue}
                                render={({ field }) => (
                                  <>
                                    <MDBSelect
                                      onChange={(item1) =>
                                        handleUserChange(
                                          item1,
                                          getValues(
                                            `dataList[${item.index}].button_type`
                                          )
                                        )
                                      }
                                      data={pbxUsersList}
                                      className="w-250px"
                                      placeholder="Select user"
                                      search
                                      value={lineValue}
                                      disabled={item.hasOwnProperty("MLA_DUMMY") || buttonNo == 1}
                                    />
                                  </>
                                )}
                              />

                            </div>
                          </div>
                          {errors?.dataList &&
                            errors.dataList[item.index]?.user_or_value && (
                              <p className="text-danger w-250px text-small">
                                {
                                  errors.dataList[item.index].user_or_value
                                    ?.message
                                }
                              </p>
                            )}
                        </td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect">
                              <input
                                type="text"
                                maxLength={lablemaxLength}
                                className="selectname-small bg-light"
                                {...register(`dataList.${item.index}.label`, {
                                  validate: (fieldValue) => {
                                    if (fieldValue === "") {
                                      return "Label should not be empty";
                                    }
                                  },
                                  // validate: "Label should not be empty",
                                  maxLength: {
                                    value: lablemaxLength,
                                  },
                                })}
                                value={label}
                                onChange={(e) =>
                                  handlLableChange(e.target.value)
                                }
                               disabled={item?.index > 0}
                                // disabled={true}
                              />
                            </div>
                          </div>
                          {errors?.dataList &&
                            errors.dataList[item.index]?.label &&
                            (errors.dataList[item.index].label?.type ==
                              "validate" ||
                              errors.dataList[item.index].label?.type ===
                              "maxLength") && (
                              <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                                {errors.dataList[item.index].label.type ==
                                  "validate"
                                  ? "Label should not be empty"
                                  : "Label must not exceed 24 characters"}
                              </p>
                            )}
                        </td>
                        <td>
                          { deviceData.mla_supported === 1 ? (
                              <div className="d-flex">
                                <div className="phoneselect">
                                  <input
                                    type="text"
                                    className="selectname-small bg-light"
                                    value={noOfMLALines}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^(|[1-9]\d*)$/.test(value)) {
                                        setNoOfMLALines(value);
                                        if (value.trim() === "") {
                                          setError(`dataList[${item.index}].no_of_mla_lines`, {
                                            type: "required",
                                            message: "Number Of Buttons Should Not Be Empty",
                                          });
                                        }else{
                                          mlaLinesChange(e);
                                          clearErrors(`dataList[${item.index}].no_of_mla_lines`);
                                        }
                                       
                                      }
                                    }}
                                    onBlur={(e) => {
                                      
                                      
                                    }
                                  }
                                    disabled={
                                      getValues(`dataList[${item.index}].user_or_value`) === "" ||
                                      getValues(`dataList[${item.index}].label`) === "" ||
                                      item.hasOwnProperty("MLA_DUMMY") || deviceData.mla_supported !== 1
                                    }
                                  />
                                </div>
                              </div>
                            ) : <>N/A</> }

                          {!item.hasOwnProperty("MLA_DUMMY") &&
                            errors?.dataList &&
                            errors.dataList[item.index]?.no_of_mla_lines &&
                            errors.dataList[item.index].no_of_mla_lines.type ==
                            "required" && (
                              <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                                {
                                  errors.dataList[item.index].no_of_mla_lines
                                    ?.message
                                }
                              </p>
                            )}
                        </td>
                        <td>
                          <div className="d-flex">
                            <div className="phoneselect bg-light">
                              <Controller
                                name={`dataList.${item.index}.ring_type`}
                                control={control}
                                shouldUnregister="true"
                                defaultValue={ringType}
                                rules={{ required: true }}
                                render={({
                                  field: { onChange, onBlur, value, ref },
                                }) => (
                                  deviceData.mla_supported === 1 ? 
                                  <MDBSelect
                                    onChange={(item1) =>
                                      handleRingChange(item1)
                                    }
                                    data={ringTypes}
                                    value={ringType}
                                    disabled={item.hasOwnProperty("MLA_DUMMY") || deviceData.mla_supported !== 1}
                                  /> :<>
                                    N/A
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </td>
                        {!item.hasOwnProperty("MLA_DUMMY") &&
                          props.buttonNo != 1 ? (
                          <td className="cursor-pointer"
                            onClick={(e) => {
                              removeFun(item.index);
                            }}
                          >
                            <MDBIcon color="primary" fas icon="times" />

                            {/* <img
                              className="close-icon ms-2"
                              src={remove1}
                              alt="Remove"
                            /> */}
                          </td>
                        ) : (
                          <td></td>
                        )}
                      </tr>
                    </>
                  );
                })}
              </table>
            </td>
          </tr>
        </>
      )}
      {buttonChange != 1 && buttonChange != 2 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
});

export const LoadBLFTemplate = React.forwardRef((props) => {
  //console.log("LoadBLFTemplate props :" + JSON.stringify(props));
  const buttonNo = props.buttonNo;
  const buttonInfo = props.buttonInfo;
  const autoDeviceContext = useAutoDeviceButtonContext();
  const {
    buttonTypes,
    ringTypes,
    pbxUsersList,
    removeFun,
    updateFun,
    addBlf,
    blfgroupsInfo,
    togleAlert,
    defualtRing,
    setRingTypeDefualt
  } = autoDeviceContext;

  const [groupError, setGroupError] = useState(false);
  const [grpInfo, setGrpInfo] = useState({});
  const {
    control,
    register,
    setValue,
    getValues,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext(); // Accessing form context

  const formValueObj = getValues("dataList")
    ? getValues("dataList")[props.index]
    : props.buttonInfo;
  const [buttonChange, setButtonChange] = useState(
    formValueObj?.button_type ? formValueObj.button_type * 1 : 2
  );
  const [lineValue, setLineValue] = useState(formValueObj?.user_or_value * 1);
  const [ringType, setRingType] = useState(formValueObj?.ring_type * 1);
  const [prevringType, prevSetRingType] = useState(formValueObj?.ring_type * 1);
  const [label, setLabel] = useState(formValueObj?.label);
  const [blflist, setBlfList] = useState([]);
  const [lineValueName, setLineValueName] = useState(
    formValueObj?.user_value_name
  );

  let lablemaxLength = 24;

  const handleButtonChange = (item) => {
    if (!item) return;
    if (buttonChange == item.value) return;
    clearErrors(`dataList.${props.index}.user_or_value`);
    if (item.value > 10) {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);
      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        return;
      }



      props.buttonInfo.blf_group_id = item.value;

      const blfGroupToInsert = removeDublicateUsers(getValues("dataList"), blfgroupsInfo[item.value]);
      let isError = bLF_Error_Checking(blfGroupToInsert, props.index, getValues("dataList"));

      if (isError) {
        // alert("phone buttons are not sufficient to add BlfGorup");
        let data = {
          type: "popup",
          title: "addBLFGroup",
          text: "addBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      if (blfGroupToInsert && blfGroupToInsert.length > 0) {
        addBlf(props.index, blfGroupToInsert);
      } else {
        return;
      }
      //setValue(`dataList.${props.index}.button_type`, 10);
      setButtonChange(10);
    } else {
      props.buttonInfo.blf_group_id = 0;
      var fieldObj = getValues(`dataList.${props.index}`);
      var jo = {
        ...fieldObj,
        button_type: parseInt(item.value),
        user_or_value: "",
        user_value_name: "",
        label: "",
      };
      console.log("updating Jo to : " + JSON.stringify(jo));
      updateFun(props.index, jo);

      props.buttonInfo.button_type = item.value;
      setButtonChange(item.value);
    }
  };
  const handlLableChange = (item) => {
    setLabel(item);
    setValue(`dataList.${props.index}.label`, item, {
      shouldDirty: true,
    });
    if (item.length > 0 && item.length <= 24) {
      clearErrors(`dataList.${props.index}.label`);
    }
  };

  const handleRingChange = (item) => {
    if (!item) return;
    if (ringType == item.value) return;

    setRingType(item.value * 1);
    setValue(`dataList.${props.index}.ring_type`, item.value, {
      shouldDirty: true,
    });
    // setValue(`dataList.${props.index}.ring_type_change`, prevringType, {
    //   shouldDirty: true,
    // });
    const allBlfFields = props.fields.filter((field)=>field.button_type == 3 || field.button_type == 10);
    allBlfFields.map((field) => {
      updateFun(field.index, {
        ...field,
        ring_type : item.value,
        ring_type_change : prevringType,
        isNewBLF:true,
      });
      setRingTypeDefualt(item.value * 1)
    });
  };

  const handleUserChange = (item1, buttonTypes) => {
    if (!item1) return;
    if (item1.value == lineValue) return;
    console.log("handleUserChange in BLF : " + item1.value + ": " + lineValue);
    let dataListValues = getValues("dataList");
    let data = checkUserAlreadyExist(dataListValues, item1.value, buttonTypes);
    if (data?.exist && item1.value !== lineValue && data?.error !== "") {
      setError(`dataList.${props.index}.user_or_value`, {
        message: data?.error,
      });
      return; // Don't allow selection
    }
    clearErrors(`dataList.${props.index}.user_or_value`);

    const [selectedUser] = pbxUsersList.filter(
      (item) => item.value == item1.value
    );
    if (selectedUser) {
      setLineValue(selectedUser.value);
      let newLabel = label && label.trim() !== "" ? label : selectedUser.label;
      setLabel(newLabel);
      setLineValueName(selectedUser.text);

      var fieldObj = getValues(`dataList.${props.index}`);
      var jo = {
        ...fieldObj,
        button_type: props.buttonInfo.button_type,
        user_or_value: selectedUser.value + "",
        user_value_name: selectedUser.text,
        label: newLabel,
      };
      console.log("updating Jo to : " + JSON.stringify(jo));
      if (newLabel && newLabel.trim() !== "") {
        clearErrors(`dataList.${props.index}.label`);
      }
      updateFun(props.index, jo);
    }
  };

  return (
    <>
      {buttonChange == 3 && (
        <tr
          key={props.id}
          ref={props.provided.innerRef}
          className={
            buttonInfo.hasOwnProperty("MLA_DUMMY") ||
              buttonInfo.no_of_mla_lines * 1 > 1
              ? "bg-secondary bg-opacity-25 dragItem"
              : "dragItem   bg-opacity-25"
          }
          {...props.provided.draggableProps}
          {...props.provided.dragHandleProps}
          style={props.style}
        >
          <td key={props.id} colSpan="7" className="w-100 p-0">
            <table
              key={props.id}
              className="datatable table-responsive mt-0 table2 w-100 p-0"
            >
              <tr className="table2" key={props.id}>
                <th className="w-10">
                  {/* <img src={dragAndDrop} className="link-icon pe-1 pb-1 " /> */}
                  <img
                    className={`link-icon pe-1 pb-1 ${buttonInfo.hasOwnProperty("MLA_DUMMY") ? "ms-4" : ""
                      }`}
                    src={
                      buttonInfo.hasOwnProperty("MLA_DUMMY")
                        ? linkicon
                        : dragAndDrop
                    }
                    alt="Remove"
                  />
                  <input
                    type="hidden"
                    {...register(`dataList.${props.index}.button_no`)}
                    value={buttonNo}
                  />
                  {props.index + 1}
                </th>
                <td>
                  <>
                    <div className="d-flex">
                      <div className="phoneselect">
                        <Controller
                          name={`dataList.${props.index}.button_type`}
                          control={control}
                          shouldUnregister="true"
                          defaultValue={buttonChange}
                          rules={{}}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <MDBSelect
                              onChange={(item) => handleButtonChange(item)}
                              data={buttonTypes}
                              value={buttonChange}
                              className="w-200px"
                              disabled={buttonInfo.hasOwnProperty("MLA_DUMMY")}
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div>
                      {groupError && <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        <b className="text-danger">{grpInfo.text}</b> already assigned to a button.
                      </p>}
                    </div>

                  </>

                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect">
                      <input
                        type="hidden"
                        name={`dataList.${props.index}.user_value_name`}
                        value={lineValueName}
                      />

                      <Controller
                        name={`dataList.${props.index}.user_or_value`}
                        control={control}
                        shouldUnregister="true"
                        rules={{ required: "Please select user" }}
                        defaultValue={lineValue}
                        render={({ field }) => (
                          <>
                            <MDBSelect
                              onChange={(item) =>
                                handleUserChange(
                                  item,
                                  getValues(`dataList[${props.index}].button_type`)
                                )
                              }
                              data={pbxUsersList}
                              className="w-250px"
                              placeholder="Select user"
                              search
                              value={lineValue}
                              disabled={buttonInfo.hasOwnProperty("MLA_DUMMY")}
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  {errors?.dataList &&
                    errors.dataList[props.index]?.user_or_value && (
                      <p className="text-danger w-250px text-small">
                        {errors.dataList[props.index].user_or_value?.message}
                      </p>
                    )}
                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect bg-light">
                      <input
                        type="text"
                        maxLength={lablemaxLength}
                        className="selectname-small bg-light"
                        {...register(`dataList.${props.index}.label`, {
                          validate: (fieldValue) => {
                            if (fieldValue === "") {
                              return "Label should not be empty";
                            }
                          },
                          // validate: "Label should not be empty",
                          maxLength: {
                            value: lablemaxLength,
                          },
                        })}
                        onChange={(e) => handlLableChange(e.target.value)}
                        disabled={buttonInfo.hasOwnProperty("MLA_DUMMY") > 0}
                      />
                    </div>
                  </div>
                  {errors?.dataList &&
                    errors.dataList[props.index]?.label &&
                    (errors.dataList[props.index].label?.type == "validate" ||
                      errors.dataList[props.index].label?.type ===
                      "maxLength") && (
                      <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        {errors.dataList[props.index].label.type == "validate"
                          ? "Label should not be empty"
                          : "Label must not exceed 24 characters"}
                      </p>
                    )}
                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect"></div>
                  </div>
                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect bg-light">
                      <Controller
                        name={`dataList.${props.index}.ring_type`}
                        control={control}
                        shouldUnregister="true"
                        defaultValue={ringType}
                        rules={{ required: true }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <MDBSelect
                            onChange={(item) => handleRingChange(item)}
                            data={ringTypes}
                            value={ringType}
                            disabled={buttonInfo.hasOwnProperty("MLA_DUMMY")}
                          />
                        )}
                      />
                    </div>
                  </div>
                </td>
                <td
                  className="text-center cursor-pointer"
                  onClick={(e) => {
                    removeFun(props.index);
                  }}
                >
                  <MDBIcon color="primary" fas icon="times" />
                  {/* <img className="close-icon" src={remove1} alt="Remove" /> */}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      )}

      {buttonChange != 3 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
});

export const LoadParkTemplate = React.forwardRef((props) => {
  const autoDeviceContext = useAutoDeviceButtonContext();
  const buttonNo = props.buttonNo;
  const buttonInfo = props.buttonInfo;
  const { buttonTypes, addBlf, blfgroupsInfo, togleAlert, removeFun, updateFun } =
    autoDeviceContext;

  const [groupError, setGroupError] = useState(false);
  const [grpInfo, setGrpInfo] = useState({});

  //console.log("loadpark template..." + props.index);
  const {
    control,
    register,
    setValue,
    getValues,
    formState: { errors },
    clearErrors,
    setError,
  } = useFormContext(); // Accessing form context
  const formValueObj = getValues("dataList")
    ? getValues("dataList")[props.index]
    : props.buttonInfo;
  const [buttonChange, setButtonChange] = useState(
    formValueObj?.button_type ? formValueObj.button_type * 1 : 4
  );
  // console.log("loadpark template buttonChange..." + buttonChange);
  const [lineValue, setLineValue] = useState(formValueObj?.user_or_value * 1);
  const [lineValueName, setLineValueName] = useState(
    formValueObj?.user_value_name
  );
  const [label, setLabel] = useState(formValueObj?.label);
  let lablemaxLength = 24;

  const handlLableChange = (item) => {
    setLabel(item);
    setValue(`dataList.${props.index}.label`, item, {
      shouldDirty: true,
    });
    if (item.length > 0 && item.length <= 24) {
      clearErrors(`dataList.${props.index}.label`);
    }
  };

  const handleChange = (item) => {
    if (!item || buttonChange == item.value) return;
    clearErrors(`dataList.${props.index}.user_or_value`); // Clear errors when button type is changed
    if (item.value > 10) {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);
      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        return;    //this code checks and return , if group already exist
      }

      props.buttonInfo.blf_group_id = item.value;
      const blfGroupToInsert = removeDublicateUsers(getValues("dataList"), blfgroupsInfo[item.value]);
      let isError = bLF_Error_Checking(blfGroupToInsert, props.index, getValues("dataList"));
      if (isError) {
        // alert("phone buttons are not sufficient to add BlfGorup");
        let data = {
          type: "popup",
          title: "addBLFGroup",
          text: "addBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      if (blfGroupToInsert && blfGroupToInsert.length > 0) {
        addBlf(props.index, blfGroupToInsert);
      } else {
        return;
      }
      setValue(`dataList.${props.index}.button_type`, 10);
      setButtonChange(10);
    } else {
      props.buttonInfo.blf_group_id = 0;
      //setValue(`dataList.${props.index}.button_type`, parseInt(item.value));
      const dataListValues = getValues("dataList");
      updateFun(props.index, {
        ...dataListValues[props.index],
        user_or_value: "",
        user_value_name: "",
        label:"",
        button_type: item.value,
      });
      setButtonChange(item.value);
    }
  };

  const handleParkChange = (item) => {
    let dataListValues = getValues("dataList");
    let data = checkUserAlreadyExist(dataListValues, item?.value);
    if (data?.exist && item.value !== lineValue && data?.error !== "") {
      setError(`dataList.${props.index}.user_or_value`, {
        message: data?.error,
      });
      return;
    }
    clearErrors(`dataList[${props.index}].user_or_value`);
    if (!item) return;
    if (item.value == lineValue) return;

    if (item.value != lineValue) {
      setLineValue(item.value);
      setValue(`dataList.${props.index}.label`, "Park " + item.value, {
        shouldDirty: true,
      });
      setValue(`dataList.${props.index}.user_value_name`, item.text, {
        shouldDirty: true,
      });
      setValue(`dataList.${props.index}.user_or_value`, item.value, {
        shouldDirty: true,
      });
      clearErrors(`dataList.${props.index}.label`);
    }
  };
  const parkExt = [];
  const parkDefaultValues = Array.from(
    { length: 90 },
    (_, index) => index + 10 // Generates numbers from 10 to 99
  );

  parkDefaultValues.map((value) => {
    var jo = {};
    jo.text = "Park Extension: " + value;
    jo.value = value;
    parkExt.push(jo);
  });
  parkExt.unshift({ text: "Select Park Extension", value: "" });

  return (
    <>
      {buttonChange == 4 && (
        <tr
          className="dragItem"
          key={props.id}
          ref={props.provided.innerRef}
          {...props.provided.draggableProps}
          {...props.provided.dragHandleProps}
        >
          <td key={props.id} colSpan="7" className="w-100 p-0 ">
            <table
              key={props.id}
              className="datatable table-responsive mt-0 table2 w-100 p-0"
            >
              <tr className="table2">
                <th className="w-10">
                  <img
                    className="link-icon pe-1 pb-1"
                    src={dragAndDrop}
                    alt="Remove"
                  />
                  <input
                    type="hidden"
                    {...register(`dataList.${props.index}.button_no`)}
                    value={buttonNo}
                  />
                  {props.index + 1}
                </th>

                <td>
                  <>
                    <div className="d-flex">
                      <div className="phoneselect">
                        <MDBSelect
                          onChange={(val) => handleChange(val)}
                          data={buttonTypes}
                          value={buttonChange}
                          className="w-200px"
                        />
                      </div>
                    </div>

                    <div>
                      {groupError && <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        <b className="text-danger">{grpInfo.text}</b> already assigned to a button.
                      </p>}
                    </div>

                  </>
                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect">
                      <Controller
                        name={`dataList.${props.index}.user_or_value`}
                        control={control}
                        shouldUnregister="true"
                        rules={{ required: "Select Park Extension" }}
                        defaultValue={lineValue}
                        render={({ field }) => (
                          <>
                            <MDBSelect
                              onChange={(val) => handleParkChange(val)}
                              data={parkExt}
                              className="w-250px"
                              value={lineValue}
                              placeholder="Select user"
                              search
                            />
                          </>
                        )}
                      />
                    </div>
                  </div>
                  {errors?.dataList &&
                    errors.dataList[props.index]?.user_or_value && (
                      <p className="text-danger w-250px text-small">
                        {errors.dataList[props.index].user_or_value?.message}
                      </p>
                    )}
                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect">
                      <input
                        type="text"
                        className="selectname-small bg-light"
                        maxLength={lablemaxLength}
                        {...register(`dataList.${props.index}.label`, {
                          validate: (fieldValue) => {
                            if (fieldValue === "") {
                              return "Label should not be empty";
                            }
                          },
                          // validate: "Label should not be empty",
                          maxLength: {
                            value: lablemaxLength,
                          },
                        })}
                        onChange={(e) => handlLableChange(e.target.value)}
                      />
                    </div>
                  </div>
                  {errors?.dataList &&
                    errors.dataList[props.index]?.label &&
                    (errors.dataList[props.index].label?.type == "validate" ||
                      errors.dataList[props.index].label?.type ===
                      "maxLength") && (
                      <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        {errors.dataList[props.index].label.type == "validate"
                          ? "Label should not be empty"
                          : "Label must not exceed 24 characters"}
                      </p>
                    )}
                </td>
                <td></td>
                <td></td>

                <td
                  className="text-center cursor-pointer"
                  onClick={(e) => {
                    removeFun(props.index);
                  }}
                >
                  <MDBIcon color="primary" fas icon="times" />
                  {/* <img className="close-icon" src={remove1} alt="Remove" /> */}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      )}

      {buttonChange != 4 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
});

export const LoadSpeedDialTemplate = React.forwardRef((props) => {
  //console.log("LoadSpeedDialTemplate is loading...." + JSON.stringify(props));
  const buttonNo = props.buttonNo;
  const buttonInfo = props.buttonInfo;
  const autoDeviceContext = useAutoDeviceButtonContext();
  const {
    buttonTypes,
    ringTypes,
    pbxUsersList,
    formValues,
    updateFun,
    addBlf,
    blfgroupsInfo,
    togleAlert,
    removeFun,
  } = autoDeviceContext;

  const {
    reset,
    control,
    register,
    unregister,
    setValue,
    getValues,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext(); // Accessing form context
  const formValueObj = getValues("dataList")
    ? getValues("dataList")[props.index]
    : props.buttonInfo;
  const [buttonChange, setButtonChange] = useState(
    buttonInfo.button_type ? buttonInfo.button_type * 1 : 5
  );
  const [lineValue, setLineValue] = useState(formValueObj?.user_or_value * 1);
  const [didValue, setDidValue] = useState(formValueObj?.custom_type == 1 ? formValueObj.custom_did_value : "");
  const [ringType, setRingType] = useState(formValueObj?.ring_type * 1);
  const [label, setLabel] = useState(formValueObj?.label);
  const [customType, setCustomType] = useState(formValueObj?.custom);
  const [lineValueName, setLineValueName] = useState(
    formValueObj?.user_value_name
  );

  const [groupError, setGroupError] = useState(false);
  const [grpInfo, setGrpInfo] = useState({});

  let lablemaxLength = 24;

  const handleButtonChange = (item) => {
    if (!item || buttonChange == item.value) return;
    clearErrors(`dataList.${props.index}.user_or_value`);
    if (item.value > 10) {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);

      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        return;
      }

      props.buttonInfo.blf_group_id = item.value;
      const blfGroupToInsert = removeDublicateUsers(getValues("dataList"), blfgroupsInfo[item.value]);
      let isError = bLF_Error_Checking(blfGroupToInsert, props.index, getValues("dataList"));
      if (isError) {
        // alert("phone buttons are not sufficient to add BlfGorup");
        let data = {
          type: "popup",
          title: "addBLFGroup",
          text: "addBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      if (blfGroupToInsert && blfGroupToInsert.length > 0) {
        addBlf(props.index, blfGroupToInsert);
      }

      setValue(`dataList.${props.index}.button_type`, 10);
      setButtonChange(10);
    } else {
      props.buttonInfo.blf_group_id = 0;
      const dataList = getValues("dataList");
      if (dataList[props.index]) {
        delete dataList[props.index].custom_type;
        delete dataList[props.index].custom
        delete dataList[props.index].custom_did_value
      }
      const dataListValues = getValues("dataList");
      updateFun(props.index, {
        ...dataListValues[props.index],
        user_or_value: "",
        user_value_name: "",
        label:"",
        button_type: item.value,
      });
      setButtonChange(item.value);
    }
    clearErrors(`dataList.${props.index}`);
  };

  const handlLableChange = (item) => {
    setLabel(item);
    setValue(`dataList.${props.index}.label`, item, {
      shouldDirty: true,
    });
    if (item.length > 0 && item.length <= 24) {
      clearErrors(`dataList.${props.index}.label`);
    }
  };
  const handleCustomDIDChange = (value) => {
    if (!value) {
      setError(`dataList.${props.index}.user_or_value`, {
        type: 'manual',
        message: 'Custom DID should not be empty',
      });
    } else if (!/^\d{10,11}$/.test(value)) {
      setError(`dataList.${props.index}.user_or_value`, {
        type: 'manual',
        message: 'Custom DID must be 10 or 11 digits',
      });
    } else if (value.length === 11 && !value.startsWith('1')) {
      setError(`dataList.${props.index}.user_or_value`, {
        type: 'manual',
        message: 'Custom DID should start with 1 if 11 digits',
      });
    } else {
      clearErrors(`dataList.${props.index}.user_or_value`);
    }

    setDidValue(value);
    setValue(`dataList.${props.index}.user_or_value`, value, {
      shouldDirty: true,
    });
    setValue(`dataList.${props.index}.user_value_name`, "");

  };

  const selectedOptionChange = (data, index) => {
    const selectedValue = data.value;
    const user_or_value = getValues(`dataList.${index}.user_or_value`);

    if (selectedValue == 0) {
      setValue(`dataList.${index}.custom`, 0);
      setValue(`dataList.${index}.user_or_value`, lineValue);
      setLineValue(lineValue);
      setCustomType(0);
      unregister(`dataList.${index}.user_or_value`);
      clearErrors(`dataList.${index}.user_or_value`);
    } else {
      setValue(`dataList.${index}.custom`, 1);
      setValue(`dataList.${index}.user_or_value`, didValue);
      setValue(`dataList.${index}.user_value_name`, ""); // Clear user_value_name for custom DID
      unregister(`dataList.${index}.user_or_value`);
      clearErrors(`dataList.${index}.user_or_value`);
      console.log("user_or_value ::: " + user_or_value);
      setCustomType(1);
    }
  };


  const handleUserChange = (item1, buttonTypes) => {
    if (!item1) return;
    if (item1.value == lineValue) return;

    let dataListValues = getValues("dataList");
    console.log("dataListValues  " + JSON.stringify(dataListValues));
    let data = checkUserAlreadyExist(dataListValues, item1.value, buttonTypes);
    if (data?.exist && item1.value !== lineValue && data?.error !== "") {
     setError (`dataList.${props.index}.user_or_value`, {
        message: data?.error,
      });
      return;
    }
    clearErrors(`dataList[${props.index}].user_or_value`);

    console.log("handleUserChange in BLF : " + item1.value);
    const [selectedUser] = pbxUsersList.filter(
      (item) => item.value == item1.value
    );
    if (selectedUser) {
      setLineValue(selectedUser.value);
      setLabel(selectedUser.label);
      setLineValueName(selectedUser.text);

      var fieldObj = getValues(`dataList.${props.index}`);
      var jo = {
        ...fieldObj,
        user_or_value: selectedUser.value + "",
        user_value_name: selectedUser.text,
        label: selectedUser.label,
      };

      console.log("Updating user selection:", JSON.stringify(jo));
      clearErrors(`dataList.${props.index}.label`);
      updateFun(props.index, jo);
    }
  };


  return (
    <>
      {buttonChange == 5 && (
        <tr
          className="dragItem"
          key={props.id}
          ref={props.provided.innerRef}
          {...props.provided.draggableProps}
          {...props.provided.dragHandleProps}
        >
          <td key={props.id} colSpan="7" className="w-100 p-0 ">
            <table
              key={props.id}
              className="datatable table-responsive mt-0 table2 w-100 p-0"
            >
              <tr className="table2">
                <th className="w-10">
                  <img
                    className="link-icon pe-1 pb-1"
                    src={dragAndDrop}
                    alt="Remove"
                  />
                  <input
                    type="hidden"
                    {...register(`dataList.${props.index}.button_no`)}
                    value={buttonNo}
                  />
                  {props.index + 1}
                </th>
                <td>
                  <>
                    <div className="d-flex">
                      <div className="phoneselect">
                        <Controller
                          name={`dataList.${props.index}.button_type`}
                          control={control}
                          shouldUnregister="true"
                          defaultValue={buttonChange}
                          rules={{}}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <MDBSelect
                              onChange={(item) => handleButtonChange(item)}
                              data={buttonTypes}
                              disabled={buttonNo == 1}
                              value={buttonChange}
                              className="w-200px"
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div>
                      {groupError && <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        <b className="text-danger">{grpInfo.text}</b>already assigned to a button. Can't select it again.
                      </p>}
                    </div>
                  </>
                </td>
                <td>
                  <div className="d-flex w-250px">

                    <MDBSelect
                      className="me-2 w-50"
                      data={[
                        { text: "Internal", value: 0 },
                        { text: "Custom DID", value: 1 },
                      ]}
                      label=''
                      value={customType}
                      onChange={(val) => selectedOptionChange(val, props.index)}
                    />

                    <div className="phoneselect" style={{ width: '49%' }}>
                      <input
                        type="hidden"
                        name={`dataList.${props.index}.user_value_name`}
                        value={lineValueName}
                      />
                      <>
                        {customType == 1 ? (
                          <>
                            <input
                              type="text"
                              placeholder="Enter value"
                              className="form-control w-100"
                              maxLength={11}
                              value={didValue}
                              {...register(`dataList.${props.index}.user_or_value`, {
                                
                              })}
                              onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, '');
                                handleCustomDIDChange(value);
                              }}
                            />

                            {errors?.dataList &&
                              errors.dataList[props.index]?.user_or_value && (
                                <p className="text-danger w-250px text-small" style={{ whiteSpace: "normal" }}>
                                  {errors.dataList[props.index].user_or_value?.message}
                                </p>
                              )}
                          </>

                        ) : (
                          <Controller
                            name={`dataList.${props.index}.user_or_value`}
                            control={control}
                            shouldUnregister={true}
                            defaultValue={lineValue}
                            rules={{ required: "Please select a user." }}
                            render={({ field }) => (
                              <>
                                <MDBSelect
                                  onChange={(item) =>
                                    handleUserChange(
                                      item,
                                      getValues(`dataList[${props.index}].button_type`)
                                    )
                                  }
                                  data={pbxUsersList}
                                  label=""
                                  className="w-250px"
                                  placeholder="Select user"
                                  search
                                  value={lineValue}
                                />
                                {errors?.dataList &&
                                  errors.dataList[props.index]?.user_or_value && (
                                    <p className="text-danger w-250px text-small">
                                      {errors.dataList[props.index].user_or_value?.message}
                                    </p>
                                  )}
                              </>
                            )}
                          />
                        )}
                      </>
                    </div>
                  </div>



                </td>
                <td>
                  <div className="d-flex">
                    <div className="phoneselect">
                      <input
                        type="text"
                        className="selectname-small bg-light"
                        maxLength={lablemaxLength}
                        value={label}
                        {...register(`dataList.${props.index}.label`, {
                          validate: (fieldValue) => {
                            if (fieldValue == "") {
                              return "Label should not be empty";
                            }
                          },
                          // validate: "Label should not be empty",
                          maxLength: {
                            value: lablemaxLength,
                          },
                        })}
                        onChange={(e) => handlLableChange(e.target.value)}
                      />
                    </div>
                  </div>
                  {errors?.dataList &&
                    errors.dataList[props.index]?.label &&
                    (errors.dataList[props.index].label?.type == "validate" ||
                      errors.dataList[props.index].label?.type ===
                      "maxLength") && (
                      <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        {errors.dataList[props.index].label.type == "validate"
                          ? "Label should not be empty"
                          : "Label must not exceed 24 characters"}
                      </p>
                    )}
                </td>
                <td></td>
                <td></td>
                <td
                  className="text-center cursor-pointer"
                  onClick={(e) => {
                    removeFun(props.index);
                  }}
                >
                  <MDBIcon color="primary" fas icon="times" />
                  {/* <img className="close-icon" src={remove1} alt="Remove" /> */}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      )}
      {buttonChange != 5 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
});

export const LoadBlankTemplate = React.forwardRef((props) => {
  const { setValue, getValues } = useFormContext(); // Accessing form context
  const autoDeviceContext = useAutoDeviceButtonContext();
  const { buttonTypes, blfgroupsInfo, addBlf, togleAlert, updateFun } = autoDeviceContext;
  const [buttonChange, setButtonChange] = useState(6);
  const buttonNo = props.buttonNo;

  const [groupError, setGroupError] = useState(false);
  const [groupErrorButton, setGroupErrorButton] = useState(0);
  const [grpInfo, setGrpInfo] = useState({});

  const handleChange = (item) => {
    if (!item) return;

    if (buttonChange == item.value) {
      return;
    }

    console.log("handleChange Blank template:" + JSON.stringify(item));
    if(item.value == 3 || item.value == 10 ){
      const allBlfFields = props.fields.filter((field)=>field.button_type == 3 || field.button_type == 10)
      allBlfFields.map((field) => {
        updateFun(field.index, {
          ...field,
          ring_type : 2,
          ring_type_change : 1,
          isNewBLF:true
        });
      });
    }
    if (item.value > 10) {

      const groupExist = getValues("dataList").find(btn => item.value * 1 == btn.blf_group_id * 1);
      if (groupExist) {
        let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
        setGrpInfo(buttonInfo);
        setGroupError(true);
        setGroupErrorButton(groupExist?.button_no)
        return;
      }

      props.buttonInfo.blf_group_id = item.value;
      const blfGroupToInsert = removeDublicateUsers(getValues("dataList"), blfgroupsInfo[item.value]);
      let isError = bLF_Error_Checking(blfGroupToInsert, props.index, getValues("dataList"));
      if (isError) {
        // alert("phone buttons are not sufficient to add BlfGorup");
        let data = {
          type: "popup",
          title: "addBLFGroup",
          text: "addBLFGrouptxt",
          button: "okay",
        };
        togleAlert(data);
        return; //phone buttons are not sufficient to add BlfGorup
      }

      if (blfGroupToInsert && blfGroupToInsert.length > 0) {
        if (blfGroupToInsert.length == 0) { //show alert that users already exist some where in button keys
          let buttonInfo = buttonTypes.find(typeobj => typeobj.value * 1 == item.value * 1);
          setGrpInfo(buttonInfo);
          setGroupError(true);
          setGroupErrorButton(groupExist?.button_no)
          return;
        }
        addBlf(props.index, blfGroupToInsert);
      } else {
        return;
      }

      //setValue(`dataList.${props.index}.button_type`, 10);
    } else {
      props.buttonInfo.blf_group_id = 0;
      const dataListValues = getValues("dataList");
      updateFun(props.index, {
        ...dataListValues[props.index],
        user_or_value: "",
        user_value_name: "",
        label:"",
        button_type: item.value,
        ring_type:item.value === 3 ? 2 : 1
      });
      setButtonChange(item.value);
    }
  };

  return (
    <>
      {buttonChange == 6 && (
        <tr
          className="dragItem"
          key={props.id}
          ref={props.provided.innerRef}
          {...props.provided.draggableProps}
          {...props.provided.dragHandleProps}
        >
          <td key={props.id} colSpan="7" className="w-100 p-0 ">
            <table
              key={props.id}
              className="datatable table-responsive mt-0 table2 w-100 p-0"
            >
              <tr className="table2">
                <th className="w-10 cursor-pointer">
                  <img
                    title="Remove"
                    className="link-icon pe-1 pb-1"
                    src={dragAndDrop}
                    alt="Remove"
                  />
                  {props.index + 1}
                </th>
                <td>
                  <>
                    <div className="d-flex">
                      <div className="phoneselect">
                        <MDBSelect
                          onChange={(val) => handleChange(val)}
                          className="w-200px"
                          data={buttonTypes}
                          value={buttonChange}
                        />
                      </div>
                    </div>
                    <div>
                      {groupError && <p className="text-danger w-200px text-small" style={{ whiteSpace: "normal" }}>
                        <p className="text-danger">User already configured as BLF at {groupErrorButton}</p>
                      </p>}
                    </div>
                  </>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </td>
        </tr>
      )}
      {buttonChange != 6 && (
        <GetTemplate
          {...props}
          buttonNo={props.index + 1}
          button_type={buttonChange}
        />
      )}
    </>
  );
});

export function LoadHeaderTemplate() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <tr className="dragItem">
        <td colSpan="7" className="w-100 p-0">
          <table className="datatable table-responsive mt-0 table2 w-100 p-0">
            <tr className="table2">
              <th className="w-10">{t("buttons")}</th>
              <td className="fw-bold">{t("Feature")}</td>
              <td className="fw-bold">{t("UserorValue")}</td>
              <td className="fw-bold">{t("Label")}</td>
              <td className="fw-bold">{t("NoOfButtons")}</td>
              <td className="fw-bold">{t("Ring")}</td>
              <td className="fw-bold">{t("remove")}</td>
            </tr>
          </table>
        </td>
      </tr>
    </>
  );
}

export function GetTemplate(props) {
  let button_type = props.button_type > 10 ? 10 : props.button_type; //for >10 we are considering it as blf Groups
  props.buttonInfo.button_type = button_type;
  console.log(
    "button_type in getTemplate... " +
    button_type +
    ": " +
    props.buttonInfo.button_type
  );
  return (
    <>
      {button_type == 1 || (button_type == 2 && <LoadMLATemplate {...props} />)}

      {button_type == 3 && <LoadBLFTemplate {...props} />}

      {button_type == 4 && <LoadParkTemplate {...props} />}

      {button_type == 5 && <LoadSpeedDialTemplate {...props} />}

      {button_type == 6 && <LoadBlankTemplate {...props} />}

      {button_type == 10 && <LoadBLFGroupsTemplate {...props} />}
    </>
  );
}
